import React from 'react';
import AdminUserPicker, { getUserLabel } from './AdminUserPicker';

// 'euros' no da birux directamente: suma lo aportado y da 1 Birux de Oro por euro entero, como
// un sub o una donacion. Es para lo que el bot no ve (Kick, TikTok, Starvios, Streamlabs...).
const TYPES = [
  { value: 'birux', label: 'Birux Bronce' },
  { value: 'biruxComodin', label: 'Birux Comodín' },
  { value: 'biruxPlata', label: 'Birux Plata' },
  { value: 'biruxOro', label: 'Birux Oro' },
  { value: 'euros', label: 'Euros aportados (1 € = 1 Birux Oro, se acumula)' }
];

const AdminBirux = () => {
  const [platform, setPlatform] = React.useState('twitch');
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [type, setType] = React.useState('birux');
  const [quantity, setQuantity] = React.useState(1);
  const [status, setStatus] = React.useState('');
  const [statusType, setStatusType] = React.useState(''); // 'success' | 'error' | ''
  const [loading, setLoading] = React.useState(false);

  const euros = type === 'euros';

  const handleGive = async () => {
    if (!selectedUser || !selectedUser._id) {
      setStatus('Selecciona un usuario');
      setStatusType('error');
      return;
    }
    const qty = Number(quantity);
    // Mismos limites que el servidor.
    if (euros ? !(qty > 0 && qty <= 10000) : !(Number.isInteger(qty) && qty >= 1 && qty <= 100000)) {
      setStatus(euros ? 'Cantidad inválida (entre 0,01 y 10000 €)' : 'Cantidad inválida (debe ser un entero entre 1 y 100000)');
      setStatusType('error');
      return;
    }
    const label = selectedUser.displayname || selectedUser.youtubeDisplayName || selectedUser._id;
    const typeLabel = TYPES.find(t => t.value === type).label;
    setLoading(true);
    setStatus('');
    setStatusType('');
    try {
      const formData = new FormData();
      formData.append('userId', selectedUser._id);
      formData.append('type', type);
      formData.append('quantity', qty);
      const res = await fetch('/api/adminLogin?action=giveBirux', {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data && data.success) {
        setStatus(euros
          ? qty + ' € sumados a ' + label + ': ' + (data.gold > 0 ? 'gana ' + data.gold + ' Birux Oro' : 'aún no completa otro euro, queda acumulado')
          : typeLabel + ' añadido correctamente (' + qty + ') a ' + label);
        setStatusType('success');
      } else {
        setStatus('Error: ' + (data && data.error ? data.error : 'desconocido'));
        setStatusType('error');
      }
    } catch (err) {
      setStatus('Error al dar birux');
      setStatusType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='heroes formOver'>
      <h1>Dar Birux</h1>
      <AdminUserPicker
        platform={platform}
        onPlatformChange={(p) => { setPlatform(p); setSelectedUser(null); }}
        selectedUser={selectedUser}
        onSelectUser={setSelectedUser}
      />
      {loading ? <p>Cargando...</p> : null}
      {selectedUser ? (
        <>
          <div className='formFieldRow'>
            <label className='formFieldLabel heroes'>Tipo</label>
            <select className='userSearch' value={type} onChange={(e) => setType(e.target.value)}>
              {TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
            </select>
          </div>
          <div className='formFieldRow'>
            <label className='formFieldLabel heroes'>{euros ? 'Euros' : 'Cantidad'}</label>
            <input
              className='userSearch'
              type='number'
              min={euros ? '0.01' : '1'}
              max={euros ? '10000' : '100000'}
              step={euros ? '0.01' : '1'}
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              onWheel={(e) => e.currentTarget.blur()}
            />
          </div>
          <div className='navTops heroes unselectable'>
            <div onClick={handleGive}>Dar a {getUserLabel(selectedUser, platform)}</div>
          </div>
        </>
      ) : null}
      {status ? (
        <p
          role={statusType === 'error' ? 'alert' : 'status'}
          style={{
            padding: '8px 12px',
            borderRadius: 4,
            fontWeight: 600,
            color: statusType === 'success' ? '#0a6b0a' : statusType === 'error' ? '#8a1a1a' : 'inherit',
            backgroundColor: statusType === 'success' ? '#d9f5d9' : statusType === 'error' ? '#fdecea' : 'transparent'
          }}
        >
          {status}
        </p>
      ) : null}
    </div>
  );
};

export default AdminBirux;
